import React from 'react';

import { Outlet, createBrowserRouter,Navigate} from 'react-router-dom';
import { ErrorCatch, PageWrapper, NotFound } from './components';

const Home = React.lazy(() => import('../modules/home'));
const NotHome = React.lazy(() => import('../modules/notHome'));
const LoginView = React.lazy(() => import('../modules/Login'))



const defaultFallback = (
    <div
        style={{
            alignItems: 'center',
            width: '100%',
            height: `70vh`,
            display: 'flex',
            justifyContent: 'center',
        }}
    >
    </div>
);

function SuspendModule(Module: any) {
    return (
        <React.Suspense fallback={Module?.fallback || defaultFallback}>
            <Module/>
        </React.Suspense>
    );
}
const appRouter = createBrowserRouter([
    {
        path: `/`,
        element: <PageWrapper/>,
        errorElement: <ErrorCatch/>,
        children: [
            {path: "error",  element: <Navigate to="auth/login" />},
            {path: "unauthorized", element: <Navigate to="auth/login" />},

            {path: "401", element: <Navigate to="auth/login" />},
            {path: "403", element: <Navigate to="auth/login" />},
            {path: "404", element: <Navigate to="auth/login" />},
            {path: "440", element: <Navigate to="auth/login" />},
            {path: "500", element: <Navigate to="auth/login" />},
            {
                path: ``,
                element: SuspendModule(LoginView),
            },
            {
                path: `auth/login`,
                element: SuspendModule(LoginView),
            },
            {
                path: `notHome`,
                element: SuspendModule(NotHome),
            },
            {path: "*", element: <Navigate to="auth/login" />},
            // {
            //     path: '*',
            //     element: <NotFound},
            //     errorElement: <ErrorCatch},
            // },
        ],
    },
]);


export default appRouter